import PropTypes from "prop-types";
import Client from "./Customer";
import Parent from "./Parent";
import { createField, getEntityTypes, getEntityDefaults } from "./utils";

const CrimePersonalInfo = {
    fileNo: createField(PropTypes.string, ""),
    prefix: createField(PropTypes.string, ""),
    consecutive: createField(PropTypes.number, 0),
    client: createField(PropTypes.shape(getEntityTypes(Client)), getEntityDefaults(Client)),
    type: createField(PropTypes.shape({}), null),
    startDate: createField(PropTypes.instanceOf(Date), null),
    alternContact: createField(PropTypes.string, ""),
    caseNo: createField(PropTypes.string, ""),
    dlNo: createField(PropTypes.string, ""),
    dateOfArrest: createField(PropTypes.instanceOf(Date), null),
    placeOfArrest: createField(PropTypes.string, ""),
    agency: createField(PropTypes.string, ""),
    status: createField(PropTypes.shape({}), null),
    notes: createField(PropTypes.string, ""),
    location: createField(PropTypes.string, ""),
    courtNo: createField(PropTypes.string, ""),
    courtDate: createField(PropTypes.instanceOf(Date), null),
    fileLocation: createField(PropTypes.shape({}), null),
    parent: createField(PropTypes.shape(getEntityTypes(Parent)), getEntityDefaults(Parent)),
    parentId: createField(PropTypes.number, null),
    trnFlowId: createField(PropTypes.number, null),
    assigneeUser: createField(PropTypes.shape({}), null),
    workStatus: createField(PropTypes.string, "casePreparation"),
};

export default CrimePersonalInfo;

// Set of date-type fields that might be used for calendar event purposes
export const getEventFields = () => [{ field: "courtDate", label: "Court Date" }];
